import { render, staticRenderFns } from "./select-work-space.vue?vue&type=template&id=652d15bb&scoped=true&"
import script from "./select-work-space.vue?vue&type=script&lang=ts&"
export * from "./select-work-space.vue?vue&type=script&lang=ts&"
import style0 from "./select-work-space.vue?vue&type=style&index=0&id=652d15bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d15bb",
  null
  
)

export default component.exports